export default __webpack_public_path__ + "static/media/blockchain-verified.a0b60471.PNG";